export const extractFileNameWithoutExtension = (fileName: string) => {
  return fileName.split(".").slice(0, -1).join(".");
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error("FileReader result is not a string"));
      }
    };

    reader.onerror = () => {
      reject(reader.error);
    };
  });
};

export const fileDownloadFromUrl = (url: string, fileName: string) => {
  const anchorElement = document.createElement("a");
  anchorElement.href = url;
  anchorElement.setAttribute("download", fileName);
  anchorElement.style.display = "none";
  document.body.appendChild(anchorElement);
  anchorElement.click();
};

export type FileMimeType = "text/plain" | "text/csv" | "application/json" | "application/pdf" | "application/octet-stream";

export const fileDownloadFromContent = (fileName: string, content: string, mimeType: FileMimeType, charset = "utf-8"): void => {
  const blob = new Blob([content], {
    type: `${mimeType};charset=${charset}`
  });

  const url: string = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement("a");

  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
